<template>
  <div class="loyalty-reward-levels-container container">
    <h4 class="heading">Reward Levels</h4>
    <div class="text">
      <p>
        Every time you shop you’ll earn points on your account - and, as you
        grow your balance, you’ll unlock earlier priority access, more benefits
        and upgrade your V.I.P. status through the levels.
      </p>
    </div>
    <h5 class="sub-heading">{{ poundsToPoints }}</h5>
    <LoyaltyLevels
      v-for="(level, index) in tiers"
      :key="index"
      :level="level"
    />
    <div class="sign-up-button">
      <Button
        type="button"
        full-width
        theme="outline"
        @click="setSlideSignUp(true)"
      >
        SIGN UP TO MEMBERS ONLY
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import LoyaltyLevels from "./LoyaltyLevels.vue";
import loyaltyTiersContent from "@/assets/json/loyalty-tiers.json";
import { mapGetters, mapActions, mapState } from "vuex";
import loyaltyQueryV2 from "@/graphql/queries/LoyaltyV2.gql";

export default {
  name: "LoyaltyRewardLevels",
  components: {
    Button,
    LoyaltyLevels,
  },
  data() {
    return {
      customer: null,
      loyaltyTiers: loyaltyTiersContent,
    };
  },
  computed: {
    ...mapState("auth", ["customerAccessToken"]),
    ...mapGetters("app", ["currencyCode"]),
    ...mapGetters("auth", ["isLoggedIn"]),
    poundsToPoints() {
      if (!this.currencyCode) {
        return;
      }

      return (
        this.$filters.toCurrency(1, this.currencyCode, 0, 0) + " = 1 POINT"
      );
    },
    tiers() {
      const tiers = this.loyaltyTiers.tiers;

      return tiers.map((tier) => {
        const hideBenefits =
          tier.secret && this.customersTier.name !== tier.name;

        const secretBenefits = tier.benefits.map(() => ({
          header: "Secret benefit",
          body: "Reach the next level to find out more",
        }));

        return {
          ...tier,
          secret: hideBenefits ? true : false,
          benefits: hideBenefits ? secretBenefits : tier.benefits,
        };
      });
    },
    customersTier() {
      return this.loyaltyTiers.tiers.find(
        (tier) => tier.name === this.customerTierName
      );
    },
    customerTierName() {
      if (this.customer?.tierName?.value) {
        return this.customer?.tierName?.value;
      }

      const tags = this.customer?.tags || [];
      if (tags.length > 0) {
        const tierTag = tags.find((tag) => tag.indexOf("tier") !== -1);
        return tierTag.replace("tier: ", "");
      }

      return "Level 1";
    },
  },
  methods: {
    ...mapActions("app", ["setSlideSignUp"]),
  },
  apollo: {
    customer: {
      query: loyaltyQueryV2,
      skip() {
        return !this.customerAccessToken?.value;
      },
      variables() {
        return {
          accessToken: this.customerAccessToken?.value,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.loyalty-reward-levels-container {
  padding-bottom: 20px;

  @include respond-above(md) {
    padding-bottom: 120px;
  }
}

.heading {
  font-family: $heading-font-family;
  font-size: 28px;
  font-weight: 400;
  margin-bottom: 10px;
  text-align: center;
  text-transform: uppercase;
  @include respond-above(md) {
    font-size: 50px;
    margin-bottom: 20px;
  }
}

.text {
  font-family: $body-font-family;
  font-size: 13px;
  font-weight: 400;
  margin: 0 0 20px;
  text-align: center;
  @include respond-above(md) {
    max-width: 452px;
    margin: 0 auto 60px;
  }
}

.sub-heading {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 60px;
  text-align: center;
  @include respond-above(md) {
    font-size: 40px;
  }
}

.sign-up-button {
  display: none;
  @include respond-above(md) {
    display: block;
    width: 300px;
    margin: 40px auto 0;
  }
}
</style>
